import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  installResizeObserverErrorSuppressor,
  installResizeObserverLoopFix,
} from './utils/suppressBenignResizeObserverError';

// React Flow trips the benign "ResizeObserver loop" notice as its canvas
// resizes (e.g. while a voice turn streams nodes in), and CRA's dev overlay
// escalates it to a fatal-looking screen. installResizeObserverLoopFix patches
// ResizeObserver so the notice is never generated; the error suppressor is a
// cheap backup. Both no-op in production / where ResizeObserver is absent.
installResizeObserverLoopFix();
installResizeObserverErrorSuppressor();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
